import React, {FC} from "react";
import {IntlProvider} from "react-intl";

import SideMenu from "./components/SideMenu/SideMenu";
import languages from "../../resources";
import AuthoredHeader from "./components/AuthoredHeader/AuthoredHeader";
import WhatsNew from "../WhatsNew/WhatsNew";
import {authStore} from "../../store/auth.store";
import {language} from "../../enum/languages.enum";
import style from "./style.module.css";

interface IAuthoredProvider {
  children: React.ReactNode
}

const AuthoredProvider: FC<IAuthoredProvider> = ({ children }) => {
  const locale = authStore(state => state.user?.language || language.en);

  return (
    <IntlProvider
      messages={languages[locale]}
      locale={language[locale]}
    >
      <div className="flex min-h-screen bg-background">
        <SideMenu />
        <div className="flex-1 lg:ml-[60px] flex flex-col">
          <AuthoredHeader />
          <div className={style.content}>
            {children}
          </div>
        </div>
      </div>
      <WhatsNew />
    </IntlProvider>
  )
}

export default AuthoredProvider
